"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterTypes = exports.FilterType = void 0;
var _availability = require("./availability");
var _badges = require("./badges");
var _bathrooms = require("./bathrooms");
var _bedrooms = require("./bedrooms");
var _blockSize = require("./block-size");
var _floorArea = require("./floor-area");
var _keywords = require("./keywords");
var _listedDate = require("./listed-date");
var _listedPropertyTypes = require("./listed-property-types");
var _listingFeatures = require("./listing-features");
var _onlyWithEvents = require("./only-with-events");
var _onlyWithPrice = require("./only-with-price");
var _parking = require("./parking");
var _price = require("./price");
var _propertyStatus = require("./property-status");
var _propertyTypes = require("./property-types");
var _saleMethods = require("./sale-methods");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var FilterTypeMap = {
  price: _price.PriceFilter,
  beds: _bedrooms.BedsFilter,
  baths: _bathrooms.BathroomsFilter,
  parking: _parking.ParkingFilter,
  floorArea: _floorArea.FloorAreaFilter,
  blockSize: _blockSize.BlockSizeFilter,
  availability: _availability.AvailabilityFilter,
  listedDate: _listedDate.ListedDateFilter,
  keywords: _keywords.KeywordsFilter,
  onlyWithPrice: _onlyWithPrice.OnlyWithPriceFilter,
  onlyWithEvents: _onlyWithEvents.OnlyWithEventsFilter,
  propertyTypes: _propertyTypes.PropertyTypesFilter,
  propertyStatus: _propertyStatus.PropertyStatusFilter,
  saleMethods: _saleMethods.SaleMethodsFilter,
  listingFeatures: _listingFeatures.ListingFeaturesFilter,
  listedPropertyTypes: _listedPropertyTypes.ListedPropertyTypesFilter,
  badges: _badges.BadgesFilter
};
var FilterTypes = exports.FilterTypes = Object.keys(FilterTypeMap);
var FilterType = exports.FilterType = Object.fromEntries(Object.entries(FilterTypeMap).map(_ref => {
  var _ref2 = _slicedToArray(_ref, 2),
    key = _ref2[0],
    value = _ref2[1];
  return [key, {
    name: key,
    urlSlug: value.urlSlug
  }];
}));